const system = {
  getMonth (daysToAdd) {
    const aux = new Date().setDate(new Date().getDate() + parseInt(daysToAdd, 10))
    return new Date(aux).getDate()
  },
  getDayOfWeek (daysToAdd) {
    const aux = new Date().setDate(new Date().getDate() + parseInt(daysToAdd, 10))
    return new Date(aux).getUTCDay()
  },
  getNowMinutes (timeZone = 'Europe/London') {
    const nowSplit = new Date().toLocaleTimeString("es-ES", {hour12: false, timeZone: timeZone}).split(':')
    const hNow = parseInt(nowSplit[0], 10)
    const mNow = parseInt(nowSplit[1], 10)
    return hNow * 60 + mNow
  },
  convertStringToMinutes (value) {
    if (!value || value.toString().indexOf(':') === -1) return value
    const aux = value.split(':')
    const h = parseInt(aux[0], 10)
    const m = parseInt(aux[1], 10)
    return (h * 60) + m
  },
  convertStringToDate (value) {
    if (!value) return null
    const aux = value.split('-')
    if (aux.length < 2) return null
    return new Date(parseInt(aux[0], 10), parseInt(aux[1], 10), parseInt(aux[2], 10))
  },
  convertDateToString (value){
    if (!value) return null
    return `${value.getFullYear()}-${value.getMonth()+1}-${value.getDate()}`
  },
  compareDates (dt1, dt2) {
    const d1 = typeof dt1 === 'string' ? this.convertStringToDate(dt1) : this.convertStringToDate(this.convertDateToString(dt1))
    const d2 = typeof dt2 === 'string' ? this.convertStringToDate(dt2) : this.convertStringToDate(this.convertDateToString(dt2))

    if (d1.getTime() === d2.getTime()) return '='
    else if (d1>d2) return '>'
    else if (d1<d2) return '<'
  },
  dtGTdt (dt1, dt2, daysToAdd = 0) {
    if (!dt2) {
      const act = new Date(new Date().setDate(new Date().getDate() + parseInt(daysToAdd, 10)))
      dt2 = `${act.getFullYear()}-${act.getMonth()+1}-${act.getDate()}`
    }
    return (this.compareDates(dt1, dt2) === '>' || this.compareDates(dt1, dt2) === '=')
  },
  dtSMdt (dt1, dt2, daysToAdd = 0) {
    if (!dt2) {
      const act = new Date(new Date().setDate(new Date().getDate() + parseInt(daysToAdd, 10)))
      dt2 = `${act.getFullYear()}-${act.getMonth()+1}-${act.getDate()}`
    }
    return (this.compareDates(dt1, dt2) === '<' || this.compareDates(dt1, dt2) === '=')
  },
  dtEQdt (dt1, dt2, daysToAdd = 0) {
    if (!dt2) {
      const act = new Date(new Date().setDate(new Date().getDate() + parseInt(daysToAdd, 10)))
      dt2 = `${act.getFullYear()}-${act.getMonth()+1}-${act.getDate()}`
    }
    // console.log(dt1, dt2, this.compareDates(dt1, dt2))
    return (this.compareDates(dt1, dt2) === '=')
  },
  tGTt (time1, time2, timeZone = 'Europe/London') {
    const t1 = this.convertStringToMinutes(time1)
    const t2 = time2 ? this.convertStringToMinutes(time2) : this.getNowMinutes(timeZone)
    return t1>=t2
  },
  tSMt (time1, time2, timeZone = 'Europe/London') {
    const t1 = this.convertStringToMinutes(time1)
    const t2 = time2 ? this.convertStringToMinutes(time2) : this.getNowMinutes(timeZone)
    return t1<=t2
  },
  alternation (start, daysToAdd, alternation, isByMonth) {
    alternation = alternation ? alternation | 0 : null
    if (!alternation || alternation === 1) return true

    //const dateStart = this.convertStringToDate(start ? start.split('T').shift() : start)
    const dateStart = new Date(Date.parse(start, 'Y-m-d'))
    const dateActual = new Date(new Date().setDate(new Date().getDate() + parseInt(daysToAdd, 10)))
    if (isByMonth) {
        const diff = dateActual.getMonth() - dateStart.getMonth()
        if ((diff % alternation) === 0) return true
    } else {
      let dsd = dateStart.getUTCDay()
      dsd = -1 * (dsd === 0 ? 7 : dsd)-1 | 0
      let dad = dateActual.getUTCDay()
      dad = -1 * (dad === 0 ? 7 : dad)-1 | 0
        const dateActualAux = dateActual.setDate(dateActual.getDate() + (-1 * parseInt((dateActual.getUTCDay() === 0 ? 7 : dateActual.getUTCDay())-1, 10)))
        const dateStartAux = dateStart.setDate(dateStart.getDate() + (-1 * parseInt((dateStart.getUTCDay() === 0 ? 7 : dateStart.getUTCDay())-1, 10)))
        const diff = parseInt(((new Date(dateActualAux) - new Date(dateStartAux)) / (1000 * 60 * 60 * 24)) / 7, 10) 
         
        if ((diff % alternation) === 0) return true
    }
    return false
  },
}
export default system
